import { usePath } from "../libs/path/PathProvider";
import AccountFilter from "./AccountFilter"
import CurrencyFilter from "./CurrencyFilter"
import TaxFilter from "./TaxFilter";
import TableShowFilter from "./TableShowFilter";
import HistoryFilter from "./HistoryFilter";
import SearchFilter from "./SearchFilter";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function Filters(){
    const {path} = usePath();
    const tax = path == "/tax" ? <TaxFilter/> : null
    const {end,setEnd} = useDateRangeFilter()
    const search = path == "/history" ? <HistoryFilter hideAccount={true}/> : <><SearchFilter/><DatePicker className="date-range" label="End" value={end} onChange={(e:dayjs.Dayjs|null)=>e&&setEnd(e)}/></>
    return <div id="filters" className="flex middle gap-8">
        <AccountFilter/>
        <CurrencyFilter/>
        {tax}
        {search}
        <div className="flex1"/>
        <TableShowFilter/>
    </div>
}